<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/userView" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>
                View
                {{ viewUser.firstname }}
                {{ viewUser.lastname }}
              </td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("system.label.edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("system.label.delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("system.label.userName") }}</b>
                    </td>
                    <td>{{ viewUser.username }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.firstName") }}</b>
                    </td>
                    <td>{{ viewUser.firstname }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.lastName") }}</b>
                    </td>
                    <td>{{ viewUser.lastname }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.email") }}</b>
                    </td>
                    <td>{{ viewUser.email }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.entityName") }}</b>
                    </td>
                    <td>{{ viewUser.officeName }}</td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("system.label.roles") }} </b>
                    </td>

                    <td class="border-none">
                      <span
                        v-for="(user, index) in viewUser.selectedRoles"
                        :key="index"
                        >{{
                          user.name +
                          (index + 1 < viewUser.selectedRoles.length
                            ? ", "
                            : "")
                        }}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      title=" User"
      @deletePressed="deleteUserData()"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      viewUser: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteUserDataPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      view: (state) => state.users.viewuserData,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData(id) {
      this.$router.push(`/userView/editUserData/${id}`);
    },
    async deleteUserData() {
      this.deleteUserDataPopup = false;
      await this.$store.dispatch("users/deleteUserDataAction", this.id);
      this.$vs.notify({
        title: "Sucessfully deleted!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
      this.$router.push(`/userView`);
    },

    async getviewUser() {
      try {
        await this.$store.dispatch("users/setviewUser", this.id);
        this.viewUser = this.view;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getviewUser();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
